(function () {
  function findTitleAnchor() {
    // Dawn / thèmes proches
    return (
      document.querySelector('.collection-hero__title')?.closest('.collection-hero') ||
      document.querySelector('h1.title--primary')?.parentElement ||
      document.querySelector('main h1')?.parentElement ||
      document.querySelector('h1')?.parentElement
    );
  }

  function getDrawerDetails() {
    // Ton drawer existe bien (tu l’as déjà vu en console)
    return document.getElementById('Details-FacetDrawer')
      || document.querySelector('details.mobile-facets__disclosure');
  }

  function ensureButton() {
    if (window.innerWidth > 749) return;

    const anchor = findTitleAnchor();
    const details = getDrawerDetails();
    if (!anchor || !details) return;

    // évite double bouton
    if (document.getElementById('bhMobileFilterBtn')) return;

    const btn = document.createElement('button');
    btn.id = 'bhMobileFilterBtn';
    btn.type = 'button';
    btn.className = 'bh-mobile-filter-btn';
    btn.innerHTML = `
      <span class="bh-mobile-filter-icon" aria-hidden="true">⎯⎯</span>
      <span>Filtrer</span>
    `;

    btn.addEventListener('click', () => {
      // Ouvre le vrai drawer Dawn
      details.open = true;
      // sécurité : force un "toggle" pour les scripts
      details.dispatchEvent(new Event('toggle'));
    });

    anchor.insertAdjacentElement('afterend', btn);
  }

  document.addEventListener('DOMContentLoaded', ensureButton);
  window.addEventListener('resize', () => setTimeout(ensureButton, 150));
})();


